import { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { StateRedux } from '../../store/type-redux';
import FormCadastro from './components/FormCadastro';
import GridUsuarios from './components/GridUsuarios';
import { Usuario, Pesquisa, Permissao } from '../../@types/exports';
import { api, alerts, doRefreshToken } from '../../utils';
import { load, AlertReact } from '../../components';

const Texto = (textoToReplace: any) => {
  const { t } = useTranslation();
  return (
    t(`usuarios.${textoToReplace}`)
  );
};
const HtmlDeletPerfil = (texto: any) => {
  const { textoToReplace } = texto;
  return (
    <div>
      <h4><b>{Texto(textoToReplace)}</b></h4>
    </div>
  );
};
const HtmlBotao = (texto: any) => {
  const { textoToReplace } = texto;
  return (
    <div>
      {Texto(textoToReplace)}
    </div>
  );
};
const HtmlToast = (texto: any) => {
  const { textoToReplace } = texto;
  return (
    <div>
      {Texto(textoToReplace)}
    </div>
  );
};
const Usuarios = () => {
  // Verifica se é necessário realizar o refresh token
  doRefreshToken.getRefreshToken();
  const { t } = useTranslation();
  const { realm } = useSelector((state: StateRedux) => state);
  const [editarItem, setEditarItem] = useState<Usuario | undefined>();
  const [permissoes, setPermissoes] = useState<Permissao[]>([]);
  const [usuarios, setUsuarios] = useState<Usuario[]>([]);
  const [usuariosFiltro, setUsuariosFiltro] = useState<Usuario[]>([]);
  const pesquisa = (data: Pesquisa): void => {
    const { filtro, quantidade } = data;
    // Verifica se é necessário realizar o refresh token
    doRefreshToken.getRefreshToken();
    if (filtro !== undefined) {
      const filtrado = usuarios
        .filter((u) => u.username.includes(filtro.toLowerCase()));

      setUsuarios(filtro.length && filtrado.length ? filtrado : usuariosFiltro);
      return;
    }

    if (quantidade !== undefined) {
      const quanti = usuariosFiltro.filter((u, i) => (i < quantidade));

      setUsuarios(!quantidade ? usuariosFiltro : quanti);
    }
  };

  const buscarUsuarios = useCallback(async () => {
    // Verifica se é necessário realizar o refresh token
    doRefreshToken.getRefreshToken();
    try {
      load.show();
      const { data } = await api.getUsuarios();
      setUsuarios(data);
      setUsuariosFiltro(data);

      load.hide();
    } catch (error) {
      alerts.exibirErrorCatch(error);
      load.hide();
    }
  }, []);

  const buscarPermissoes = useCallback(async () => {
    // Verifica se é necessário realizar o refresh token
    doRefreshToken.getRefreshToken();
    try {
      load.show();

      const { data } = await api.getPermissoes();
      setPermissoes(data);

      load.hide();
    } catch (error) {
      alerts.exibirErrorCatch(error);
      load.hide();
    }
  }, []);
  const removerItem = async (usuario: Usuario) => {
    // Verifica se é necessário realizar o refresh token
    doRefreshToken.getRefreshToken();
    load.show();
    AlertReact.message({
      html: <HtmlDeletPerfil textoToReplace="deletarUsuario" />,
      showDenyButton: true,
      denyButtonText: <HtmlBotao textoToReplace="botoes.voltar" />,
    })
      .then((result) => {
        try {
          if (result.isConfirmed) {
            api.removerUsuario(usuario.id);
            const removido = usuarios.filter((item) => item.id !== usuario.id);
            setUsuarios(removido);
            toast.success(
              <div>
                {usuario.firstName}
                &nbsp;
                {usuario.lastName}
                <HtmlToast textoToReplace="excluido" />
              </div>,
            );
          }
        } catch (error) {
          alerts.exibirErrorCatch(error);
        } finally {
          load.hide();
        }
      });
  };

  useEffect(() => {
    buscarUsuarios();
    buscarPermissoes();
  }, [buscarUsuarios, buscarPermissoes, realm]);

  return (
    <Container fluid>
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">{t('usuarios.usuarios')}</h1>
      </div>

      <GridUsuarios
        usuarios={usuarios}
        pesquisa={pesquisa}
        setEditarItem={setEditarItem}
        removerItem={removerItem}
      />

      <FormCadastro
        atualizarLista={buscarUsuarios}
        itemParaEditar={editarItem}
        permissoes={permissoes}
      />
    </Container>
  );
};

export default Usuarios;
